<template>
    <div :class="{'detail-banner-ctn': true, 'banner-tall': image && image.size && image.size === 1}">
        <div class="detail-banner">
            <swipe class="swipe" :auto="4000" :speed="500" :showIndicators="false" :showPicIcon="true" @afterSlide="bannerSlided" v-if="image">
                <swipe-item class="swipe-item" v-for="(item, index) in image.productImageList" :key="item.id + '@' + index" v-if="Array.isArray(image.productImageList)">
                    <img :src="resizeBannerImage(item.imageUrl)" v-if="index === 0 || (isMounted && ((index === image.productImageList.length - 1) || (index - bannerIndex <= 1 && index - bannerIndex >= -1)))">
                </swipe-item>
            </swipe>
            <div class="product-info">
                <span class="sale-out" v-if="status == 0">已下架</span>
                <span class="sale-out" v-if="saleEmpty == 1">已售罄</span>
                <span class="type" v-if="prdTmpId !== 3 && title && title.classBrandParentName">
                    {{title.classBrandParentName}}
                    <span v-if="prdTmpId === 4 && destinationName"> | {{destinationName}}</span>
                </span>
                <span v-if="prdTmpId == 3">
                    <span v-if="newLineTypeName">{{newLineTypeName}}
                        <span v-if="classBrandId === 105"> | {{destinationName}}</span>
                    </span>
                </span>
                <span class="id" v-if="title && title.productId">产品编号：{{title.productId}}</span>
            </div>
            <groupDynamics :status="status" :supportGroupBuying="supportGroupBuying" :groupActivity="groupActivity"></groupDynamics>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from '@/components/detail/swipe/index';
const { resizeImage } = require('@tuniu/light-helper');
import groupDynamics from './groupBuying/groupDynamics';

export default {
    name: 'banner',
    data: function () {
        return {
            changeOpcity: '0',
            fontColor: 'rgb(255,255,255)',
            backgroundColor: 'rgba(0,0,0,0.6)',
            bannerIndex: 0,
            isMounted: false
        }
    },
    props: {
        image: {
            type: Object,
            default: function() {
                return {
                    size: 2,
                    productImageList: []
                }
            }
        },
        title: {
            type: Object,
            default: function() {
                return {
                }
            }
        },
        status: {
            type: Number,
            default: 1
        },
        prdTmpId: {
            type: Number,
            default: 0
        },
        destinationName: {
            type: String,
            default: ''
        },
        newLineTypeName:{
            type: String,
            default: '',
        },
        isApp: {
            type: Boolean,
            default: false
        },
        //是否为拼团产品
        supportGroupBuying: {
          type: Boolean,
          default: false
        },
        groupActivity: {
          type: Object,
          default: () => ({})
        },
        classBrandId: {
            type: Number,
            default: 0
        },
        saleEmpty: {
            type: Number,
            default: 0
        }
    },
    mounted: function () {
        window.addEventListener('scroll', this.updateState, false);
        setTimeout(() => { this.isMounted = true; }, 300);
    },
    beforeDestroy: function() {
        window.removeEventListener('scroll', this.updateState, false);
    },
    methods: {
        resizeBannerImage (imgUrl) {
            return resizeImage(imgUrl.replace(/https?:/, ''), 1024, 768, 0);
        },
        updateState () {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let tip = (scrollTop / 225 > 1) ? 1 : scrollTop / 225;
            let color = (scrollTop - 225 > 0) ? 0 : (225 - scrollTop);
            let backgroundColor = (1 - scrollTop / 225 > 0) ? (1 - scrollTop / 225) * 0.6 : 0;
            this.changeOpcity = tip;
            this.fontColor = 'rgb(' + color + ',' + color + ',' + color + ')';
            this.backgroundColor = 'rgba(0,0,0,' + backgroundColor + ')'
        },
        bannerSlided (index) {
            this.bannerIndex = index;
        }
    },
    components: {
        'swipe': Swipe,
        'swipe-item': SwipeItem,
        groupDynamics
    }
}
</script>

<style lang="scss">
.detail-banner-ctn {
    padding: 0;
    background: #fff;
    &.banner-tall {
        padding: 0;
        .detail-banner {
            padding-top: 75%;
            border-radius: 0;
            box-shadow: none;
            .swipe {
                border-radius: 0;
                &:after {
                    border-radius: 0;
                    top: auto;
                    height: 40px;
                    background-image: linear-gradient(top, rgba(51, 51, 51, 0), rgba(0, 0, 0, 0.5));
                }
                .mint-swipe-items-wrap{
                    border-radius: 0;
                }
            }
        }
    }
}
.detail-banner {
    position: relative;
    overflow: hidden;
    // border-radius: 9px;
    padding-top: 50%;
    box-shadow: 0 10px 10px rgba(59, 66, 75, 0.1);
    .swipe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        overflow: hidden;
        // border-radius: 9px;
        &:after {
            content: "";
            position: absolute;
            z-index: 1;
            bottom: 0;
            height: 100%;
            left: 0;
            right: 0;
            background-image: linear-gradient(-180deg, rgba(39,40,44,0.00) 47%, rgba(31,31,45,0.86) 100%);
            opacity: 0.66;
            // border-bottom-left-radius: 9px;
            // border-bottom-right-radius: 9px;
        }
    }
    .mint-swipe-items-wrap
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .product-info {
        position: absolute;
        bottom: 0;
        left: 10px;
        right: 10px;
        z-index: 2;
        height: 33px;
        color: #fff;
        font-size: 13px;
        line-height: 33px;
        .type {
            float: left;
            & > span {
                font-weight: 300;
            }
        }
        .id {
            float: right;
            font-weight: 300;
        }
        .sale-out {
            position: absolute;
            top: -20px;
            left: 0;
            display: inline-block;
            background: #000;
            opacity: .5;
            padding: 0 5px;
            border-radius: 12px;
            line-height: 23px;
            font-size: 13px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Banner.vue